<template>
  <div>
    <div class="d-flex justify-content-between">
      <h1 class="page-header">
        {{ $t('stockTransfer.stock_transfer') }}
      </h1>
      <ts-breadcrumb
        :items="[
          { text: $t('home'), href: '/' },
          {
            text: $t('stockTransfer.stock_transfer'),
            href: '/stock-transfers'
          },
          { text: $t('stockTransfer.edit'), active: true }
        ]"
      />
    </div>
    <ts-card>
      <ts-card-wrapper>
        <ts-loading-banner :loading="ready_fetch">
          <form class="form-horizontal">
            <div class="row mb-3">
              <div class="col-sm-12 col-lg-6 col-md-12">
                <div class="form-group row">
                  <label class="col-md-4 form-col-label control-label required">
                    {{ $t('stockTransfer.date') }}
                  </label>
                  <div class="col-md-7">
                    <ts-date-picker-input
                      v-model="model.transfer_date"
                    ></ts-date-picker-input>
                    <div class="validate" v-if="errors.has('transfer_date')">
                      {{ errors.first('transfer_date') }}
                    </div>
                  </div>
                </div>
                <div class="form-group row">
                  <label class="col-md-4 form-col-label control-label"> </label>
                  <div class="col-md-7">
                    <ts-checkbox
                      v-model="chk_current_branch"
                      @change="setCurrentBranch"
                      >{{ $t('stockTransfer.to_current_branch') }}</ts-checkbox
                    >
                  </div>
                </div>
                <div class="form-group row" v-if="chk_current_branch">
                  <label class="col-md-4 form-col-label control-label required">
                    {{ $t('stockTransfer.to_location') }}
                    <i class="fas fa-spinner spin" v-if="fetchToWarehouse"></i>
                  </label>
                  <div class="col-md-7">
                    <select
                      class="form-control"
                      v-model="model.to_location_id"
                      :disabled="fetchToWarehouse"
                      :class="{ 'is-invalid': errors.has('to_location_id') }"
                    >
                      <option value="" disabled selected style="display: none">
                        {{ $t('select') }}
                      </option>
                      <option
                        v-for="(warehouse, index) in toWarehouses"
                        :key="index"
                        :value="warehouse.location_id"
                      >
                        {{ warehouse.location_name_en }}
                      </option>
                    </select>
                    <div
                      class="invalid-feedback"
                      v-if="errors.has('to_location_id')"
                    >
                      {{ errors.first('to_location_id') }}
                    </div>
                  </div>
                </div>
                <div class="form-group row" v-if="!chk_current_branch">
                  <label class="col-md-4 form-col-label control-label required">
                    {{ $t('stockTransfer.to_branch') }}
                  </label>
                  <div class="col-md-7">
                    <select
                      class="form-control"
                      v-model="model.to_branch_id"
                      :class="{ 'is-invalid': errors.has('to_branch_id') }"
                      @change="onChangeBranch"
                    >
                      <option value="" disabled selected style="display: none">
                        {{ $t('select') }}
                      </option>
                      <option
                        v-for="(branch, index) in branches"
                        :key="index"
                        :value="branch.branch_id"
                      >
                        {{ branch.branch_name_en }}
                      </option>
                    </select>
                    <div
                      class="invalid-feedback"
                      v-if="errors.has('to_branch_id')"
                    >
                      {{ errors.first('to_branch_id') }}
                    </div>
                  </div>
                </div>
                <div class="form-group row" v-if="!chk_current_branch">
                  <label class="col-md-4 form-col-label control-label required">
                    {{ $t('stockTransfer.to_location') }}
                    <i class="fas fa-spinner spin" v-if="fetchToWarehouse"></i>
                  </label>
                  <div class="col-md-7">
                    <select
                      class="form-control"
                      v-model="model.to_location_id"
                      :disabled="fetchToWarehouse"
                      :class="{
                        'is-invalid': errors.has('to_location_id')
                      }"
                    >
                      <option value="" disabled selected style="display: none">
                        {{ $t('select') }}
                      </option>
                      <option
                        v-for="(warehouse, index) in toWarehouses"
                        :key="index"
                        :value="warehouse.location_id"
                      >
                        {{ warehouse.location_name_en }}
                      </option>
                    </select>
                    <div
                      class="invalid-feedback"
                      v-if="errors.has('to_location_id')"
                    >
                      {{ errors.first('to_location_id') }}
                    </div>
                  </div>
                </div>
                <div class="form-group row">
                  <label class="col-md-4 form-col-label control-label">
                    {{ $t('stockTransfer.transferComment') }}
                  </label>
                  <div class="col-md-7">
                    <textarea
                      v-model="model.transfer_comment"
                      rows="5"
                      class="form-control"
                    ></textarea>
                    <div class="validate" v-if="errors.has('transfer_comment')">
                      {{ errors.first('transfer_comment') }}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </form>
          <div class="row">
            <div class="col-md-12">
              <div id="container-table">
                <table class="table ui-table table-hover">
                  <thead>
                    <tr>
                      <th style="width: 14%">
                        {{ $t('stockTransfer.barcode') }}
                      </th>
                      <th style="width: 14%">
                        {{ $t('stockTransfer.productGroup') }}
                      </th>
                      <th style="width: 25%">
                        {{ $t('stockTransfer.product') }}
                      </th>
                      <!-- <th style="width: 9%">
                        {{ $t('stockTransfer.uom') }}
                      </th>
                      <th style="width: 7%">
                        {{ $t('stockTransfer.cost') }}
                      </th> -->
                      <th class="text-center" style="width: 20%">
                        {{ $t('stockTransfer.serialRange') }}
                      </th>
                      <th class="text-center" style="width: 15%">
                        {{ $t('stockTransfer.availableQuantity') }}
                      </th>
                      <th class="text-center" style="width: 9%">
                        {{ $t('stockTransfer.qty') }}
                      </th>
                      <th style="width: 2%" class="text-center">
                        <a href="#" class="text-primary">
                          <i class="fas fa-spinner spin" v-if="ready_fetch"></i>
                          <i
                            class="fa fa-plus"
                            v-else
                            @click.prevent="addNewRow"
                          ></i>
                        </a>
                      </th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr
                      v-for="(item,
                      index) in model.sub_item_list_by_serial_range"
                      :key="index"
                    >
                      <td>
                        <a-select
                          ref="barcode"
                          v-model="
                            item.product ? item.product.barcode : item.barcode
                          "
                          class="ts-w-full"
                          showSearch
                          :filterOption="
                            (input, option) =>
                              option.componentOptions.children[0].text
                                .toLowerCase()
                                .indexOf(input.toLowerCase()) >= 0
                          "
                          @change="barcodeChange(item)"
                          @inputKeydown="onEnterOrTab"
                        >
                          <a-select-option
                            v-for="(pro, index) in productNotIncludeSelected({
                              addedProducts:
                                model.sub_item_list_by_serial_range,
                              excludeProductId: item.product_id
                            }).map(el => ({
                              value: el.barcode,
                              label: el.barcode
                            }))"
                            :key="index"
                            :value="pro.value"
                            >{{ pro.label }}</a-select-option
                          >
                        </a-select>
                        <div
                          class="validate"
                          v-if="
                            errors.has(
                              'sub_item_list_by_serial_range.' +
                                index +
                                '.barcode'
                            )
                          "
                        >
                          {{
                            errors.first(
                              'sub_item_list_by_serial_range.' +
                                index +
                                '.barcode'
                            )
                          }}
                        </div>
                      </td>
                      <td>
                        <input
                          disabled
                          type="text"
                          v-model="item.pro_group_name_en"
                          step="any"
                          class="form-control only-border-bottom"
                        />
                      </td>
                      <td>
                        <a-select
                          v-model="item.product_id"
                          class="ts-w-full"
                          showSearch
                          :filterOption="
                            (input, option) =>
                              option.componentOptions.children[0].text
                                .toLowerCase()
                                .indexOf(input.toLowerCase()) >= 0
                          "
                          @change="productChange(item)"
                          @inputKeydown="onEnterOrTab"
                        >
                          <a-select-option
                            v-for="(pro, index) in productNotIncludeSelected({
                              addedProducts:
                                model.sub_item_list_by_serial_range,
                              excludeProductId: item.product_id
                            }).map(el => ({
                              value: el.product_id,
                              label: el.product_name_en
                            }))"
                            :key="index"
                            :value="pro.value"
                            >{{ pro.label }}</a-select-option
                          >
                        </a-select>
                        <div
                          class="validate"
                          v-if="
                            errors.has(
                              'sub_item_list_by_serial_range.' +
                                index +
                                '.product_id'
                            )
                          "
                        >
                          {{
                            errors.first(
                              'sub_item_list_by_serial_range.' +
                                index +
                                '.product_id'
                            )
                          }}
                        </div>
                      </td>
                      <!-- <td>
                        <select
                          class="form-control only-border-bottom"
                          :class="{
                            'is-invalid': errors.has(
                              'sub_item_list_by_serial_range.' + index + '.uom_id'
                            )
                          }"
                          v-model="item.uom_id"
                          @change="onUomChange(item)"
                        >
                          <option
                            value=""
                            disabled
                            selected
                            style="display: none"
                          >
                            --Select--
                          </option>
                          <option
                            v-for="(uom, index) in getUom(item)"
                            :key="index"
                            :value="uom.uom_id"
                          >
                            {{ uom.uom_name_en }}
                          </option>
                        </select>
                        <div
                          class="invalid-feedback"
                          v-if="
                            errors.has('sub_item_list_by_serial_range.' + index + '.uom_id')
                          "
                        >
                          {{
                            errors.first('sub_item_list_by_serial_range.' + index + '.uom_id')
                          }}
                        </div>
                      </td>
                      <td>
                        <input
                          disabled
                          type="number"
                          v-model.number="item.cost"
                          step="any"
                          class="form-control only-border-bottom"
                        />
                      </td> -->
                         <td class="text-center">
                        <a-input-group compact>
                          <a-input
                            v-model="item.serial_start"
                            style="width: 100px; text-align: center"
                            placeholder="Minimum"
                          />
                          <a-input
                            style="
                              width: 30px;
                              border-left: 0;
                              pointer-events: none;
                              background-color: #fff;
                            "
                            placeholder="~"
                            disabled
                          />
                          <a-input
                            v-model="item.serial_end"
                            style="
                              width: 100px;
                              text-align: center;
                              border-left: 0;
                            "
                            placeholder="Maximum"
                          />
                        </a-input-group>
                      </td>
                      <td>
                        <input
                          type="number"
                          v-model.number="item.ending_balance"
                          disabled
                          class="form-control only-border-bottom ts-text-center"
                        />
                      </td>
                      <td>
                        <input
                          type="number"
                          v-model.number="item.quantity"
                          @keypress.enter="onQuantiy(index)"
                          step="any"
                          class="form-control only-border-bottom ts-text-center"
                          :class="{
                            'is-invalid': errors.has(
                              'sub_item_list_by_serial_range.' +
                                index +
                                '.quantity'
                            )
                          }"
                        />
                        <div
                          class="invalid-feedback"
                          v-if="
                            errors.has(
                              'sub_item_list_by_serial_range.' +
                                index +
                                '.quantity'
                            )
                          "
                        >
                          {{
                            errors.first(
                              'sub_item_list_by_serial_range.' +
                                index +
                                '.quantity'
                            )
                          }}
                        </div>
                      </td>
                      <td class="text-center">
                        <a
                          href="#"
                          class="text-danger"
                          @click.prevent="removeRow(item)"
                        >
                          <i class="fa fa-trash"></i>
                        </a>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
              <!-- <table
                style="width: 100%"
                class="mt-2"
                id="amountValue"
                v-if="model.sub_item_list_by_serial_range.length"
              >
                <tr>
                  <td style="width: 80%" class="text-right">
                    <label class="col-form-label">
                      {{ $t('stockTransfer.grand_total') }} :
                    </label>
                  </td>
                  <td class="pl-2 pr-5" style="width: 16%">
                    <input
                      disabled
                      type="number"
                      v-model.number="model.total_amount"
                      step="any"
                      class="form-control only-border-bottom"
                    />
                  </td>
                </tr>
              </table> -->
            </div>
          </div>
          <div class="row mt-3">
            <div class="col-md-12 text-right ts-space-x-3">
              <ts-button
                class="btn-default"
                @click="$router.push({ name: 'stock-transfer' })"
              >
                {{ $t('cancel') }}
              </ts-button>
              <ts-button
                color="primary"
                outline
                @click.prevent="updatePreview"
                :waiting="waiting"
                  :disabled="hasQuantityExceedingBalance"
                v-if="model.sub_item_list_by_serial_range.length"
              >
                {{ $t('updatePreview') }}
              </ts-button>
              <ts-button
                color="primary"
                @click.prevent="update"
                :waiting="saving"
                   :disabled="hasQuantityExceedingBalance"
                v-if="model.sub_item_list_by_serial_range.length"
              >
                {{ $t('update') }}
              </ts-button>
            </div>
          </div>
        </ts-loading-banner>
      </ts-card-wrapper>
      <a-modal :title="$t('pdf')" width="50%" v-model="show_pdf" :footer="null">
        <ts-preview-pdf v-model="waiting" :src="src" />
      </a-modal>
    </ts-card>
  </div>
</template>

<script>
import { mapState, mapGetters } from 'vuex'
import { Errors } from 'form-backend-validation'
import moment from 'moment'

export default {
  name: 'stock-transfer-edit',
  data() {
    return {
      model: {
        stock_transfer_id: 0,
        transfer_date: moment().format('DD-MM-YYYY'),
        report_template: 'transfer',
        to_location_id: '',
        to_branch_id: '',
        transfer_comment: '',
        total_amount: 0,
        sub_item_list_by_serial_range: []
      },
      newRow: {
        stock_transfer_detail_id: 0,
        barcode: '',
        pro_group_name_en: '',
        product_id: '',
        uom_id: '',
        cost: 0,
        quantity: null,
        serial_start: null,
        serial_end: null
      },
      chk_current_branch: true,
      errors: new Errors(),
      ready_fetch: false,
      fetchToWarehouse: false,
      src: '',
      saving: false,
      waiting: false,
      show_pdf: false
    }
  },
  computed: {
    ...mapState('stock/stockTransfer', [
      'to_warehouses',
      'products',
      'uom',
      'branches',
      'edit_data'
    ]),
    ...mapGetters('stock/stockTransfer', [
      'getUom',
      'getDefaultUom',
      'productPrice',
      'totalAmount',
      'productNotIncludeSelected'
    ]),
    toWarehouses() {
      if (this.model.to_branch_id) {
        return _.orderBy(this.to_warehouses, ['location_name_en']).filter(
          w => w.branch_id == this.model.to_branch_id
        )
      }
      return this.to_warehouses
    },
      hasQuantityExceedingBalance () {
    return this.model.sub_item_list_by_serial_range.some(item => {
      return item.quantity > (item.ending_balance || 0)
    })
  }
  },
  created() {
    this.fetchResourceBeforeCreate()
  },
  methods: {
    fetchResourceBeforeCreate() {
      this.ready_fetch = true
      this.$store
        .dispatch('stock/stockTransfer/dataBeforeCreate')
        .then(() => {
          this.ready_fetch = false
          this.model.to_branch_id = this.edit_data.to_branch_id
          this.onChangeBranch()
          this.setEditData()
        })
        .catch(error => {
          this.ready_fetch = false
          this.$toasted.error(error.message)
        })
    },
    setCurrentBranch() {
      this.model.to_location_id = this.model.to_branch_id = ''
      this.onChangeBranch()
    },
    onChangeBranch() {
      this.fetchToWarehouse = true
      this.model.to_location_id = ''
      this.$store
        .dispatch('stock/stockTransfer/getToWarehouses', {
          to_branch_id: this.model.to_branch_id
        })
        .finally(() => {
          this.fetchToWarehouse = false
        })
    },
    addNewRow() {
      this.model.sub_item_list_by_serial_range.unshift(_.clone(this.newRow))
      if (this.model.sub_item_list_by_serial_range.length > 0) {
        this.$nextTick(() => {
          this.$refs.barcode[0].focus()
        })
      }
    },
    removeRow(item) {
      this.model.sub_item_list_by_serial_range.splice(
        this.model.sub_item_list_by_serial_range.indexOf(item),
        1
      )
    },
    barcodeChange(item) {
      if (!item.barcode) {
        item.product_id = ''
        item.uom_id = ''
        return
      }
      let result = this.products.filter(p => p.barcode == item.barcode)
      item.product_id = result[0].product_id
      item.uom_id = this.getDefaultUom(item.product_id)
      item.pro_group_name_en = result[0].group.pro_group_name_en
      this.onUomChange(item)
      this.fetchAvailableProduct(item)
    },
    productChange(item) {
      if (!item.product_id) {
        item.product_id = ''
        item.uom_id = ''
        return
      }
      let result = this.products.filter(p => p.product_id == item.product_id)
      item.barcode = result[0].barcode
      item.uom_id = this.getDefaultUom(item.product_id)
      item.pro_group_name_en = result[0].group.pro_group_name_en
      this.onUomChange(item)
      this.fetchAvailableProduct(item)
    },
    onUomChange(item) {
      try {
        let productPrice = this.productPrice(item.product_id, item.uom_id)
        productPrice
          ? (item.cost = _.ceil(productPrice.sale_price, 2))
          : (item.cost = 0)
      } catch (e) {
        item.cost = ''
      }
    },
    grandTotal() {
      this.model.sub_item_list_by_serial_range.forEach(el => {
        if (el.serial_end && el.serial_start) {
          // slice(-10) because some serial number it's too big to calculate
          el.quantity =
            parseInt(el.serial_end.slice(-15)) -
            parseInt(el.serial_start.slice(-15)) +
            1
        }
      })
      this.model.total_amount = _.ceil(
        _.sumBy(this.model.sub_item_list_by_serial_range, detail =>
          this.totalAmount(detail)
        ),
        2
      )
    },

    update() {
      this.errors = new Errors()
      this.saving = true
      this.$store
        .dispatch(
          'stock/stockTransfer/update',
          Object.assign({}, this.model, {
            chk_current_branch: this.chk_current_branch,
            report_template: ''
          })
        )
        .then(response => {
          this.$toasted.success(response.message)
          this.$router.push({ name: 'stock-transfer' })
        })
        .catch(error => {
          this.saving = false
          if (
            error.message === 'To branch not found main warehouse.' ||
            error.message ===
              'Transfer across branch is for user that assign to main warehouse.' ||
            error.message ===
              'The current user not yet belong to any warehouses.'
          ) {
            this.$toasted.info(error.message)
          } else {
            this.$toasted.error(error.message)
          }
          this.errors = new Errors(error.errors)
        })
        .finally(() => {
          this.saving = false
        })
    },
    updatePreview() {
      this.errors = new Errors()
      this.waiting = true
      this.$store
        .dispatch(
          'stock/stockTransfer/update',
          Object.assign({}, this.model, {
            chk_current_branch: this.chk_current_branch,
            report_template: 'transfer'
          })
        )
        .then(response => {
          this.show_pdf = true
          this.src = response.url
          this.$toasted.success(response.message)
          this.clearInput()
        })
        .catch(error => {
          this.waiting = false
          this.show_pdf = false
          if (
            error.message === 'To branch not found main warehouse.' ||
            error.message ===
              'Transfer across branch is for user that assign to main warehouse.' ||
            error.message ===
              'The current user not yet belong to any warehouses.'
          ) {
            this.$toasted.info(error.message)
          } else {
            this.$toasted.error(error.message)
          }
          this.errors = new Errors(error.errors)
        })
        .finally(() => {
          this.waiting = false
        })
    },
    // setEditData() {
    //   if (this.edit_data.from_branch_id != this.edit_data.to_branch_id) {
    //     this.chk_current_branch = false
    //   }
    //   this.model = {
    //     stock_transfer_id: this.edit_data.stock_transfer_id,
    //     transfer_date: this.edit_data.transfer_date,
    //     to_location_id: this.edit_data.to_location_id,
    //     to_branch_id: this.edit_data.to_branch_id,
    //     transfer_comment: this.edit_data.transfer_comment,
    //     total_amount: this.edit_data.total_amount,
    //     sub_item_list_by_serial_range: []
    //   }
    //   this.edit_data.stock_transfer_details.forEach(detail => {
    //     this.model.sub_item_list_by_serial_range.unshift({
    //       stock_transfer_id: detail.stock_transfer_id,
    //       barcode: detail.product.barcode,
    //       pro_group_name_en: detail.product.pro_group_name_en,
    //       product_id: detail.product_id,
    //       quantity: detail.quantity,
    //       cost: detail.cost,
    //       uom_id: detail.uom_id,
    //       serial_start: detail.serial_start,
    //       serial_end: detail.serial_end,
    //     })
    //   })
    // },
    setEditData() {
  if (this.edit_data.from_branch_id != this.edit_data.to_branch_id) {
    this.chk_current_branch = false
  }
  this.model = {
    stock_transfer_id: this.edit_data.stock_transfer_id,
    transfer_date: this.edit_data.transfer_date,
    to_location_id: this.edit_data.to_location_id,
    to_branch_id: this.edit_data.to_branch_id,
    transfer_comment: this.edit_data.transfer_comment,
    total_amount: this.edit_data.total_amount,
    sub_item_list_by_serial_range: []
  }
  
  this.edit_data.stock_transfer_details.forEach(detail => {
    const item = {
      stock_transfer_id: detail.stock_transfer_id,
      barcode: detail.product.barcode,
      pro_group_name_en: detail.product.pro_group_name_en,
      product_id: detail.product_id,
      quantity: detail.quantity,
      cost: detail.cost,
      uom_id: detail.uom_id,
      serial_start: detail.serial_start,
      serial_end: detail.serial_end,
      ending_balance: 0 // Initialize with 0
    }
    
    this.model.sub_item_list_by_serial_range.unshift(item)
    
    // Fetch available quantity for each product
    this.fetchAvailableProduct(item)
  })
},
    filterProductFunction(search, options) {
      return options.filter(option => {
        option = typeof option === 'object' ? option.text : option

        return option.toLowerCase().includes(search.toLowerCase())
      })
    },
    clearInput() {
      this.to_location = ''
      this.chk_current_branch = true
      this.model = {
        transfer_date: moment().format('DD-MM-YYYY'),
        to_location_id: '',
        to_branch_id: '',
        transfer_comment: '',
        sub_item_list_by_serial_range: [],
        total_amount: null
      }
    },
    onQuantiy(index) {
      this.addNewRow()
      this.$nextTick(() => {
        this.$refs.barcode[0].focus()
      })
    },
    onEnterOrTab(e) {
      if (e.key == 'Enter' || e.key == 'Tab') {
        this.$nextTick(() => {
          this.$refs.quantity[0].focus()
        })
      }
    },
     fetchAvailableProduct(item) {
      this.ready_fetch = true
      this.$store
        .dispatch('stock/stockTransfer/fetchAvailableProduct', {
          product_id: item.product_id
        })
        .then(response => {
          if (response && response.length > 0) {
            // Use $set to ensure reactivity
            this.$set(item, 'ending_balance', parseFloat(response[0].ending_balance || 0))
          } else {
            this.$set(item, 'ending_balance', 0)
          }
        })
        .catch(error => {
          this.loading = false
          this.$toasted.error(error.message)
        })
        .finally(() => {
          this.ready_fetch = false
        })
    },
      preventNegative(event, item, field) {
    // Prevent minus sign, plus sign, and 'e' (scientific notation)
    if (event.key === '-' || event.key === '+' || event.key === 'e' || event.key === 'E') {
      event.preventDefault()
    }
  },
  
  // Or use this alternative that also validates on input
  validateQuantity(item) {
    if (item.quantity < 0) {
      item.quantity = 0
    }
  }
  },
  watch: {
    'model.sub_item_list_by_serial_range': {
      handler() {
        this.grandTotal()
      },
      deep: true
    }
  },
  beforeRouteLeave(to, from, next) {
    this.$store.commit('stock/stockTransfer/RESET_STATE')
    this.$store.commit('stock/stockTransfer/SET_TO_WAREHOUSES', [])
    this.$store.commit('stock/stockTransfer/SET_BRANCHES', [])
    next()
  }
}
</script>
<style lang="css" scoped>
#container-table {
  max-height: 40vh;
  overflow-y: scroll;
  overflow-x: hidden;
  scrollbar-width: none;
  -ms-overflow-style: none;
}
::-webkit-scrollbar {
  width: 3px; /* Remove scrollbar space */
  background: transparent; /* Optional: just make scrollbar invisible */
}
/* Optional: show position indicator in red */
::-webkit-scrollbar-thumb {
  background: rgb(194, 194, 194);
}
table td {
  vertical-align: middle;
}
.only-border-bottom {
  border-top: none;
  border-left: none;
  border-right: none;
  outline: none;
}
.table > thead > tr > th {
  position: sticky;
  position: -webkit-sticky;
  top: 0;
  z-index: 2;
}
.table > tbody > tr > td {
  padding-top: 5px !important;
  padding-bottom: 5px !important;
  border: none !important;
}
#amountValue tr > td {
  padding: 5px;
}
</style>
